import $ from 'jquery';
import _ from 'underscore';
import { generateGuid } from '@bingads-webui-universal/primitive-utilities';
import { ProductGroupBidLandscape } from '@bingads-webui/bid-landscape';
import { getInlineEditableSaveFunction } from './product-groups-inline-edit';

class ProductGroupBidLandscapePopupFactory {
  constructor({
    deps,
    view,
  }) {
    this.deps = deps;
    this.view = view;
    this.trackingId = null;
  }

  onFetchBidLandscapeSuccess = ({
    i18n, event, item, view, data, instrumentation,
  }) => {
    const activities = {
      recordBidChangeInLandScape:
        instrumentation.productGroupGrid.create().recordBidChangeInLandScape.create(),
      recordFetchLandScapeData:
        instrumentation.productGroupGrid.create().recordFetchLandScapeData.create(),
    };

    const landscape = new ProductGroupBidLandscape({
      instrumentation,
      i18n,
      inSimpleMode: false,
      parentItem: {
        Id: item.Id,
        Name: item.attributeDisplayName,
        CurrentValue: this.deps.decimal.fromFloatToString(item.BidAmount),
      },
      dataToShow: data,
      enityType: 'ProductGroup',
    });

    activities.recordFetchLandScapeData.trace(`Fetch BSC bid landscape success for${item.Id}`);

    landscape.once('rendered', () => {
      this.trackingId = generateGuid();
      const ariaData = {
        Id: item.Id,
        ActionName: 'ViewBSCBidLandscape',
        UIData: {
          bidList: landscape.viewModel.dataArray(),
          currencyCode: this.deps.pageContext.AccountCurrencyCode,
          currentBid: item.BidAmount.Bid.Amount,
          startDate: landscape.viewModel.startDateString(),
          endDate: landscape.viewModel.endDateString(),
          trackingId: this.trackingId,
        },
      };
      activities.recordFetchLandScapeData.trace(ariaData, 'ViewBSCBidLandscape');
    });

    landscape.render();

    landscape.on('apply', () => {
      const currentSelectedId = landscape.viewModel.currentSelectedId();
      const landscapePointsLength = landscape.viewModel.landscapePointsLength();
      const isCustomBid = currentSelectedId === landscapePointsLength;

      const bidValue = this.deps.decimal.fromLocalToFloat(landscape.valueToApply());
      const message = `Apply bsc bidlandscape success for ${item.Id}:${item.BidAmount.Bid.Amount}->${bidValue}. Currency: ${this.deps.pageContext.AccountCurrencyCode}, DataDate: ${landscape.viewModel.startDateString()}~${landscape.viewModel.endDateString()}, IsCustomBid: ${isCustomBid}, TrackingId: ${this.trackingId}`;

      const updated = _.pick(item, 'Id', 'CampaignId', 'AdGroupId', 'BidAmount', 'IsExcluded');
      updated.BidAmount.Bid.Amount = bidValue;

      getInlineEditableSaveFunction(this.deps)({
        view,
        i18n,
        fieldName: ['BidAmount', 'IsExcluded'],
        updated,
        // This parameter will be invoked its `setErrors()` method when error occurs.
        editorView: {
          setErrors: (errorMapping) => {
            this.deps.popupUtil.close();
            view.grid.inlineError.setErrors({
              [item.Id]: _.values(errorMapping),
            });
          },
        },
        editorViewCallbackAfterUpdate: () => {
          activities.recordBidChangeInLandScape.trace(message);
          this.deps.popupUtil.close();
        },
      });
    });

    landscape.on('cancel', () => {
      this.deps.popupUtil.close();
    });

    if (landscape.hasData()) {
      this.deps.popupUtil.render(landscape.$el);
    } else {
      new this.deps.PopoverView({
        target: $(event.target),
        className: 'product-group-popover-bidlandscape',
        position: this.deps.positions.relativeToTableRow({
          marginBottom: $('footer > .navbar-footer').height(),
        }),
      }).setContent(new this.deps.contents.TitledContent().setBody(i18n.getString('ProductGroupsGrid_KeywordBidLandscape_UnClickableIconText')));
    }
  };

  openBidLandscapePanel = ({
    i18n,
    event,
    item,
    view,
    instrumentation,
  }) => {
    this.deps.popupUtil.close();
    event.stopPropagation();

    $.advertiser.ajaxPost({
      url: '/Campaign/BidLandscape/FetchProductGroupBidLandscapeData',
      data: { id: item.Id },
      ignoreBeforeAjax: true,
      onSuccess: (data) => {
        if (!data || (data.Errors && !_.isEmpty(data.Errors))) {
          return;
        }
        this.onFetchBidLandscapeSuccess({
          i18n, event, item, view, data, instrumentation,
        });
      },
    });
  };

  showBidLandscapePopup({ event, item }) {
    return this.openBidLandscapePanel({
      i18n: this.deps.i18n,
      event,
      item,
      view: this.view,
      instrumentation: this.deps.instrumentation,
    });
  }
}

export { ProductGroupBidLandscapePopupFactory };
